import {
  Alignment,
  Button,
  Classes,
  Dialog,
  FileInput,
  FormGroup,
  HTMLSelect,
  Icon,
  InputGroup,
  NonIdealState,
  Slider,
  Switch,
  Tab,
  Tabs,
  Tooltip,
} from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { ICalc, ISimplesTabela, newCalc, newISimplesTabela } from "../../model";
import { ICalcVar } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { LookupStore } from "../../stores/LookupStore";
import { toast } from "react-toastify";
import { getMomentFormatter, sortBy } from "../../utils";
import {
  filterIcmsClassificacao,
  IcmsClassificacaoSelect,
  renderIcmsClassificacao,
} from "../utils/IcmsClassificacaoSelect";
import { ProdutoMultiSelect } from "../produto/ProdutoMultiSelect";
import { CalcVarDialog } from "./CalcVarDialog";
import { CalcVarGrid } from "./CalcVarGrid";
import MomentLocaleUtils from "react-day-picker/moment";
import { CalcVarFcpDialog } from "./CalcVarFcpDialog";
import { CalcVarFcpGrid } from "./CalcVarFcpGrid";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { handleGetSecao, handleGetTabela } from "../utils/TabelaSimplesUtils";
import { DefaultSelect, filterItens, renderItens } from "../utils/DefaultSelect";
import { ProdutoSelect } from "../produto/ProdutoSelect";
import { CfopMultiSelect } from "../cfop/CfopMultiSelect";
import { CstOrigemMultiSelect } from "../cfop/CstOrigemMultiSelect";
import { CstMultiSelect } from "../cfop/CstMultiSelect";
import { PisCofinsMultiSelect } from "../cfop/PisCofinsMultiSelect";
import { TribuNacionalMultiSelect } from "../cfop/TribuNacionalMultiSelect";
import { CstOrigemStore } from "../../stores/legislacao/CstOrigemStore";
import { CstStore } from "../../stores/legislacao/CstStore";
import { PisCofinsStore } from "../../stores/legislacao/PisCofinsStore";
import { TribuNacionalStore } from "../../stores/legislacao/TribuNacionalStore";
import { CfopStore } from "../../stores/legislacao/CfopStore";
import { CalcStore } from "../../stores/calculo/CalcStore";
import ReactJson from "react-json-view";
import { MDBCol, MDBRow } from "mdbreact";
import LoadingModal from "../loading/LoadingModal";
import { NotaVarStore } from "../../stores/vars/NotaVarStore";
import { NotaVarFcpStore } from "../../stores/vars/NotaVarFcpStore";
import { Editor } from "primereact/editor";
import CalcClassificacaoUser from "../calculos/CalcClassificacaoUser";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";

interface CalcRsFormProps {
}

interface CalcRsFormState {
}

@observer
export class CalcRsForm extends React.Component<CalcRsFormProps, CalcRsFormState> {

  obs = observable({
    calc: {} as ICalc,
    editingVar: null as ICalcVar,
    creatingVar: false as boolean,
    saving: false as boolean,
    loading: true as boolean,
    editingVarFcp: null as ICalcVar,
    creatingVarFcp: false as boolean,
    calcId: window.location.pathname.split("/")[3] as string,
    listContas: [] as any[],
    anexo: newISimplesTabela() as ISimplesTabela,
    secao: newISimplesTabela() as ISimplesTabela,
    tabela: newISimplesTabela() as ISimplesTabela,
    open_import_produtos: false as boolean,
    open_erros_import_produtos: false as boolean,
    file_name: "Selecione um arquivo CSV" as string,
    erros_import: [] as any,
    loading_import: false as boolean,
    open_empresas: false,
    empresas: [] as any,
    listempresas: [] as any[],
    open_forcar_cfop: false as boolean,
  })


  constructor(props: CalcRsFormProps) {
    super(props);
    AppStore.setTitle("Fórmula de Cálculo");
    this.obs.loading = true;

    this.obs.calc = createViewModel(newCalc())
    CalcRSStore.obs.tab_codigos = "origem"
  }

  validarVariaveisUsuario(variaveis: ICalcVar[], predefinidas: string[], aba: string): { valido: boolean; erros: string[] } {

    const definidas = new Set<string>(predefinidas);

    const erros: string[] = [];

    for (let i = 0; i < variaveis.length; i++) {

      const { nome, expr } = variaveis[i];

      const tokens = [...expr.matchAll(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/g)].map(t => t[0]);

      const naoDefinidas = tokens.filter(token => !definidas.has(token) && !/^\d+$/.test(token));

      if (naoDefinidas.length > 0) {

        erros.push("");
        toast.error(`${aba} "${nome}" depende de variáveis não definidas antes: ${naoDefinidas.join(", ")}`)

      } else {

        let expressaoSubstituida = expr;

        definidas.forEach(v => {

          const regex = new RegExp(`\\b${v}\\b`, 'g');

          expressaoSubstituida = expressaoSubstituida.replace(regex, '1');

        });

        try {

          new Function(`return ${expressaoSubstituida}`)();

        } catch (e) {

          erros.push("");
          toast.error(`Erro de sintaxe na expressão da variável "${nome}".`)

        }

      }

      definidas.add(nome);

    }

    return {
      valido: erros.length === 0,
      erros,
    };

  }

  handleSave = async () => {

    this.obs.saving = true;

    const resultado = this.validarVariaveisUsuario(this.obs.calc.vars, NotaVarStore.obs.vars.map(x => x.nome), "Variável");

    if (!resultado.valido) return this.obs.saving = false;

    const resultadoFCP = this.validarVariaveisUsuario(this.obs.calc.vars_fcp, NotaVarFcpStore.obs.vars_fcp.map(x => x.nome), "Variável FCP");

    if (!resultadoFCP.valido) return this.obs.saving = false;

    if (this.obs.listContas.length > 0) {

      this.obs.calc.contas_id = this.obs.listContas

    } else {

      this.obs.calc.contas_id = null

    }

    if (!this.obs.calc.icms_classificacao_id) {

      toast.warning('É necessário selecionar uma Classfificação!', {});

      this.obs.saving = false;

      return

    }

    if (this.obs.listempresas.length > 0) {
      this.obs.calc.empresa_cnpj = this.obs.listempresas
    } else {
      this.obs.calc.empresa_cnpj = null
    }

    let res = await CalcRSStore.handleSave(this.obs.calc);

    if (res) {

      AppStore.setLocation("/calcs-rs");

    }

    this.obs.saving = false;

  };

  handleCancel = () => {
    AppStore.setLocation("/calcs-rs");
  };

  handleEdit = (_var: ICalcVar) => {
    this.obs.creatingVar = false;
    this.obs.editingVar = _var;
  };

  handleEditFcp = (_var: ICalcVar) => {
    this.obs.creatingVarFcp = false;
    this.obs.editingVarFcp = _var;
  };

  handleCreateVar = () => {
    this.obs.creatingVar = true;
    this.obs.editingVar = {
      id: null,
      order: this.obs.calc.vars.length + 1,
      nome: "",
      expr: "",
      descricao: "",
      saida: false,
      entrada: false,
    };
  };

  handleCreateVarFcp = () => {
    this.obs.creatingVarFcp = true;
    this.obs.editingVarFcp = {
      id: null,
      order: this.obs.calc.vars_fcp.length + 1,
      nome: "",
      expr: "",
      descricao: "",
      saida: false,
      entrada: false,
    };
  };

  async componentDidMount() {
    this.obs.loading = true;

    await LookupStore.loadIcmsClassificacoes("RS");

    await CstOrigemStore.handleLoadCstOrigem()
    await CstStore.handleLoadCst()
    await PisCofinsStore.handleLoadPisCofins()
    await TribuNacionalStore.handleLoadTribuNacional()
    await CfopStore.load_cfops();
    await NotaVarStore.load();
    await NotaVarFcpStore.load();

    CalcRSStore.obs.filter = ""

    if (this.obs.calcId) {

      CalcStore.obs.tipo = window.location.pathname.split("/")[4] || "entrada"

      let calc = await CalcRSStore.get(this.obs.calcId, CalcRSStore.obs.tipo);

      this.obs.calc = observable(calc);

      this.obs.listContas = this.obs.calc.contas_id ? this.obs.calc.contas_id : []
      this.obs.listempresas = this.obs.calc.empresa_cnpj ? this.obs.calc.empresa_cnpj : []

      AppStore.setTitle(calc.nome || "Edita Forma de Cálculo");

    } else {

      this.obs.calc = newCalc();

      this.obs.listContas = []
      this.obs.listempresas = []

    }

    if (this.obs.calc.anexo) { this.obs.anexo = this.obs.calc.anexo }
    if (this.obs.calc.secao) { this.obs.secao = this.obs.calc.secao }
    if (this.obs.calc.tabela) { this.obs.tabela = this.obs.calc.tabela }

    await CalcRSStore.loadContas()

    this.forceUpdate();

    this.obs.loading = false;

  }

  handleMoveVarUp = (_var: ICalcVar) => {
    CalcRSStore.moveVarUp(this.obs.calc, _var);
  };

  handleMoveVarDown = (_var: ICalcVar) => {
    CalcRSStore.moveVarDown(this.obs.calc, _var);
  };

  handleDelete = (_var: ICalcVar) => {
    CalcRSStore.deleteVar(this.obs.calc, _var);
  };

  handleCalcVarDialogClose = () => {
    this.obs.editingVar = null;
  };

  handleCalcVarDialogConfirm = () => {
    if (this.obs.creatingVar) {
      CalcRSStore.appendVar(this.obs.calc, this.obs.editingVar);
    }
  };

  handleMoveVarFcpUp = (_var: ICalcVar) => {
    CalcRSStore.moveVarUpFcp(this.obs.calc, _var);
  };

  handleMoveVarFcpDown = (_var: ICalcVar) => {
    CalcRSStore.moveVarDownFcp(this.obs.calc, _var);
  };

  handleDeleteFcp = (_var: ICalcVar) => {
    CalcRSStore.deleteVarFcp(this.obs.calc, _var);
  };

  handleCalcVarFcpDialogClose = () => {
    this.obs.editingVarFcp = null;
  };

  handleCalcVarFcpDialogConfirm = () => {
    if (this.obs.creatingVarFcp) {
      CalcRSStore.appendVarFcp(this.obs.calc, this.obs.editingVarFcp);
    }
  };

  async handleExport() {
    await CalcRSStore.exportProdutos(this.obs.calcId)
  }

  async handleChangeNfse(checked: boolean) {
    this.obs.calc.nfse = checked
    this.obs.calc.nfe = false
    this.obs.calc.cte = false
    this.obs.calc.nfce = false
  }

  handleChangeAnexo(e: any) {
    this.obs.calc.anexo = e
    this.obs.anexo = e

    this.obs.calc.secao = newISimplesTabela()
    this.obs.calc.tabela = newISimplesTabela()
    this.obs.secao = newISimplesTabela()
    this.obs.tabela = newISimplesTabela()
  }

  handleChangeSecao(e: any) {
    this.obs.calc.secao = e
    this.obs.secao = e

    this.obs.calc.tabela = newISimplesTabela()
    this.obs.tabela = newISimplesTabela()
  }

  handleChangeSemServicos(e: any) {
    const newValue = e.target.checked;
    this.setState({ sem_servicos: newValue })
    this.obs.calc.sem_servicos = newValue;
  }

  async handleChangeTab(tableId) {

    CalcRSStore.obs.tab_codigos = String(tableId)

  }

  async openImportProdutos() {

    this.obs.open_import_produtos = true

  }

  handleFileInputChange = async (event) => {

    const file = event.target.files[0];

    this.obs.file_name = file.name

    var data = new FormData();
    data.append("file", file);
    data.append("id_calculo", this.obs.calcId);
    data.append("estado", "rs");
    data.append("entrada", this.obs.calc.entrada ? "1" : "0");


    this.obs.open_import_produtos = false

    this.obs.loading_import = true

    let erros = await CalcStore.handleImportProdutos(data)

    this.obs.loading_import = false

    this.obs.file_name = "Selecione um arquivo CSV"

    if (erros.length) {

      this.obs.erros_import = erros

      this.obs.open_erros_import_produtos = true

    }

  };

  openSelectEmpresas(row) {

    this.obs.empresas = row

    this.obs.open_empresas = true
  }

  handleCloseEmpresas() {

    this.obs.open_empresas = false

    this.obs.empresas = []

  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar"
      />
    );
  };

  render() {

    let tagStyle: any = {
      width: 20,
      height: 20,
      lineHeight: "20px",
      textAlign: "center",
      borderRadius: "50%",
      backgroundColor: this.obs.calc.vars.length == 0 ? "#ccc" : "#0a0",
      color: this.obs.calc.vars.length > 0 ? "#fff" : null,
      fontSize: 11,
      display: "block",
      marginLeft: 5,
      float: "right",
      top: 4,
      position: "relative",
    };

    let tagStyleFcp: any = {
      width: 20,
      height: 20,
      lineHeight: "20px",
      textAlign: "center",
      borderRadius: "50%",
      backgroundColor: this.obs.calc.vars_fcp.length == 0 ? "#ccc" : "#0a0",
      color: this.obs.calc.vars_fcp.length > 0 ? "#fff" : null,
      fontSize: 11,
      display: "block",
      marginLeft: 5,
      float: "right",
      top: 4,
      position: "relative",
    };

    return (
      <>
        {this.obs.loading ?

          <div className="spinner-border" role="status">
            <span className="sr-only" />
          </div>

          :

          <div className="calc-form" style={{ marginBottom: 50 }}>
            <Tabs id="tabs">
              <Tab id="details" title="Detalhes" panel={this.renderDetails()} />
              <Tab
                disabled={this.obs.loading}
                id="rules"
                title="Regras"
                panel={this.renderRules()}
              />
              <Tab
                disabled={this.obs.loading}
                id="variables"
                children={
                  <>
                    <span style={{ float: "left" }}>Variáveis</span>
                    <span style={tagStyle}>{this.obs.calc.vars.length}</span>
                  </>
                }
                panel={this.renderVariables()}
              />

              <Tab
                disabled={this.obs.loading}
                id="variables_fcp"
                children={
                  <>
                    <span style={{ float: "left" }}>Variáveis FCP</span>
                    <span style={tagStyleFcp}>{this.obs.calc.vars_fcp?.length}</span>
                  </>
                }
                panel={this.renderVariablesFCP()}
              />
              <Tab id="contas" title="Contas" panel={this.renderSelectContas()} />
              <Tab id="descritivo" title="Descritivo do Cálculo" panel={this.renderDescritivoCalculo()} />
              <Tab id="classificacao" title="Classificação Usuário" panel={<CalcClassificacaoUser calc={this.obs.calc}/>} />
            </Tabs>

            <div className="nz-button-panel">
              <Button
                intent="primary"
                disabled={this.obs.loading}
                onClick={this.handleSave}
                loading={this.obs.saving}
                style={{ marginRight: "10px" }}
              >
                Salvar
              </Button>
              <Button
                disabled={this.obs.loading || this.obs.saving}
                onClick={this.handleCancel}
              >
                Cancelar
              </Button>
            </div>


          </div>
        }

        <Dialog
          isOpen={this.obs.open_import_produtos}
          title={"Importar Produtos"}
        >
          <div className={Classes.DIALOG_BODY}>

            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
              <b>Observação:</b> Ao importar o arquivo, todos os produtos cadastrados no cálculo serão substituídos pelos produtos presentes no arquivo. <br />
              Após a conclusão da importação, a página será atualizada.
            </p>

            <br />

            <FormGroup label="">
              <FileInput text={this.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_import_produtos = false} />
            </div>
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_erros_import_produtos}
          title={"Erros ao Importar Produtos"}
        >
          <div className={Classes.DIALOG_BODY}>

            <div style={{ height: 400, overflow: "auto" }}>
              <ReactJson
                collapsed={false}
                displayDataTypes={true}
                src={this.obs.erros_import}
              />
            </div>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => {
                this.obs.open_erros_import_produtos = false;
                window.location.reload()
              }} />
            </div>
          </div>
        </Dialog>

        <LoadingModal open={this.obs.loading_import} onClose={() => this.obs.loading_import = false} title={"Importando produtos"} />

      </>
    );
  }

  renderDetails() {
    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <>
        <FormGroup
          label="Nome"
          labelFor="nome"
          labelInfo="(obrigatório)"
        >
          <InputGroup
            id="nome"
            value={this.obs.calc.nome}
            onChange={(e: any) => this.obs.calc.nome = e.target.value}
            disabled={this.obs.loading}
          />
        </FormGroup>

        <FormGroup
          label="Classificação"
          labelFor="classificacao"
          labelInfo="(obrigatório)"
          className="empresaSelect"
        >
          <IcmsClassificacaoSelect
            items={LookupStore.obs.icms_classificacoes}
            itemRenderer={renderIcmsClassificacao}
            itemPredicate={filterIcmsClassificacao}
            onItemSelect={item => this.obs.calc.icms_classificacao_id = item.id}
            disabled={this.obs.loading}
          >
            <Button
              text={LookupStore.lookupIcmsClassificacao(
                this.obs.calc.icms_classificacao_id,
              ) || "Selecionar classificação"}
              rightIcon="double-caret-vertical"
              alignText={Alignment.LEFT}
              style={{ width: 500 }}
            />
          </IcmsClassificacaoSelect>
        </FormGroup>

        <FormGroup
          label="Prioridade"
          labelFor="prioridade"
        >
          <div style={{ width: 600 }}>
            <Slider
              value={this.obs.calc.prioridade}
              min={0}
              max={100}
              labelStepSize={10}
              onChange={(e: number) => this.obs.calc.prioridade = e}
              disabled={this.obs.loading}
            />
          </div>
        </FormGroup>

        <FormGroup
          label="Vigência"
          labelFor="vigencia"
        >
          <div style={{ width: 600, display: "flex", alignItems: "center" }}>
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.calc.valido_de ? new Date(this.obs.calc.valido_de) : null}
              onChange={val =>
                this.obs.calc.valido_de = val}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
            <Icon icon="arrow-right" style={{ margin: "0 10px" }} />
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.calc.valido_ate
                ? new Date(this.obs.calc.valido_ate)
                : null}
              onChange={val =>
                this.obs.calc.valido_ate = val}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
          </div>
        </FormGroup>

        <div className="nz-horizontal-form">

          <div className="horizontal">
            <FormGroup>
              <Switch
                className="select-regras"
                label="Base de Cálculo"
                checked={this.obs.calc.base_calculo_sped}
                onChange={(e: any) => this.obs.calc.base_calculo_sped = e.target.checked}
              />
            </FormGroup>
          </div>

          <div className="horizontal">
            <FormGroup>
              <Switch
                className="select-regras"
                label="Cálculo Exclusivo"
                checked={this.obs.calc.exclusivo}
                onChange={(e: any) => this.obs.calc.exclusivo = e.target.checked}
                disabled={this.obs.calcId ? true : false}
              />
            </FormGroup>
          </div>

        </div>

        <MDBRow>

          <MDBCol md="2">
            <FormGroup label="CFOP Sped Estadual">
              <InputGroup
                value={this.obs.calc.cfop_sped_estadual}
                onChange={(e) => this.obs.calc.cfop_sped_estadual = e.target.value}
                type="text" />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="CFOP Sped Interestadual">
              <InputGroup
                value={this.obs.calc.cfop_sped_interestadual}
                onChange={(e) => this.obs.calc.cfop_sped_interestadual = e.target.value}
                type="text" />
            </FormGroup>
          </MDBCol>

        </MDBRow>

        <FormGroup
          label="Dados do recolhimento"
          labelFor="recolhimento"
        >
          <MDBRow>
            <MDBCol>
              <FormGroup label="Código">
                <InputGroup
                  value={this.obs.calc.recolhimento?.codigo_recolhimento}
                  onChange={(e) => this.obs.calc.recolhimento.codigo_recolhimento = e.target.value}
                  type="text" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="Descrição">
                <InputGroup
                  value={this.obs.calc.recolhimento?.descricao}
                  onChange={(e) => this.obs.calc.recolhimento.descricao = e.target.value}
                  type="text" />
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="Periodicidade">
                <HTMLSelect
                  onChange={(e) => this.obs.calc.recolhimento.periodicidade = e.target.value}
                  value={this.obs.calc.recolhimento?.periodicidade}
                >
                  <option value="">Selecione</option>
                  <option value="mensal">Mensal</option>
                  <option value="quinzenal">Quinzenal</option>
                  <option value="trimestral">Trimestral</option>
                  <option value="semanal">Semanal</option>
                  <option value="por_nota">Por Nota</option>
                  <option value="trimestral_mensal">Trimestral / Mensal</option>
                  <option value="por_vencimento">Por Vencimento</option>
                </HTMLSelect>
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="Período Subsequente">
                <HTMLSelect
                  onChange={(e) => this.obs.calc.recolhimento.periodo_subsequente = e.target.value}
                  value={this.obs.calc.recolhimento?.periodo_subsequente}
                >
                  <option value="">Selecione</option>
                  <option value="1_mes">1º Mês</option>
                  <option value="2_mes">2º Mês</option>
                  <option value="3_mes">3º Mês</option>
                  <option value="4_mes">4º Mês</option>
                  <option value="5_mes">5º Mês</option>
                  <option value="6_mes">6º Mês</option>
                  <option value="7_mes">7º Mês</option>
                  <option value="1_semana">1º Semana</option>
                  <option value="2_semana">2º Semana</option>
                  <option value="1_quinzena">1º Quinzena</option>
                  <option value="2_quinzena">2º Quinzena</option>
                  <option value="no_mesmo_mes">No mesmo mês</option>
                </HTMLSelect>
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="Forma de vencimento">
                <HTMLSelect
                  onChange={(e) => this.obs.calc.recolhimento.forma_vencimento = e.target.value}
                  value={this.obs.calc.recolhimento?.forma_vencimento}
                >
                  <option value="">Selecione</option>
                  <option value="dias_corridos_antecipados">Dias Corridos Antecipados</option>
                  <option value="dias_corridos_adiados">Dias Corridos Adiados</option>
                  <option value="dias_uteis">Dias úteis</option>
                  <option value="dias_corridos_direto">Dias Corridos Direto</option>
                  <option value="ultimo_dia_util">Último dia útil</option>
                  <option value="no_mesmo_dia_da_nota">No mesmo dia da nota</option>
                  <option value="ultimo_dia_adiado">Último dia adiado</option>
                </HTMLSelect>
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <FormGroup label="Código Sped Fiscal">
                <InputGroup
                  value={this.obs.calc.recolhimento?.codigo_sped_fiscal}
                  onChange={(e) => this.obs.calc.recolhimento.codigo_sped_fiscal = e.target.value}
                  type="text" />
              </FormGroup>
            </MDBCol>
          </MDBRow>
        </FormGroup>

      </>
    );
  }

  renderRules() {

    let anexos = [
      { "cod": "1", "descricao": "Anexo I - Comércio" },
      { "cod": "2", "descricao": "Anexo II - Indústria" },
      { "cod": "3", "descricao": "Anexo III - Locação de Bens Móveis e Prestação de Serviços (não relacionados no § 5º-C do art. 18 da LC 155/2016)" },
      { "cod": "4", "descricao": "Anexo IV - Prestação de Serviços (relacionados no § 5º-C do art. 18 da LC 155/2016)" },
      { "cod": "5", "descricao": "Anexo V - Prestação de Serviços (relacionados no § 5º-1 do art. 18 da LC 155/2016)" }
    ]

    let secao = handleGetSecao(this.obs.anexo.cod)

    let tabela = handleGetTabela(this.obs.secao.cod)

    let anexoText = this.obs.anexo.descricao != "" ? `${this.obs.anexo.descricao}`
      : "Selecione um Anexo";

    let secaoText = this.obs.secao.descricao != "" ? `${this.obs.secao.descricao}`
      : "Selecione uma Seção";

    let tabelaText = this.obs.tabela.descricao != "" ? `${this.obs.tabela.descricao}`
      : "Selecione uma Tabela";


    return (
      <>
        <div className="nz-horizontal-form">
          <FormGroup
            label="Aplicar a empresas do tipo"
            labelFor="tipo_empresa"
            style={{ marginRight: 15 }}
          >
            <HTMLSelect
              onChange={e => {
                this.obs.calc.tipo_empresa = e.target.value === "" ? null : e.target.value;
              }}
              value={this.obs.calc.tipo_empresa === null ? "" : this.obs.calc.tipo_empresa}
            >
              <option value="">Todos</option>
              <option value="industrial">
                Industrial, importador, arrematante ou engarrafador
              </option>
              <option value="distribuidor">
                Distribuidor, depósito ou estabelecimento atacadista
              </option>
            </HTMLSelect>
          </FormGroup>


          {!this.obs.calc.nfse &&
            <>
              <FormGroup label="Regra de produtos" style={{ marginRight: 15 }}>
                <HTMLSelect
                  onChange={e => this.obs.calc.regra_produtos = e.target.value}
                  value={this.obs.calc.regra_produtos}
                >
                  <option value="inclusivo">
                    Aplicar somente aos produtos selecionados
                  </option>
                  <option value="exclusivo">
                    Aplicar a todos os produtos, exceto aqueles selecionados
                  </option>
                </HTMLSelect>
              </FormGroup>

              <FormGroup label="Produtos selecionados" style={{ marginRight: 15 }}>
                {this.obs.calcId ?
                  <ProdutoMultiSelect
                    entrada_saida={this.obs.calc.entrada ? "entrada" : "saida"}
                    value={this.obs.calc.confaz}
                    estado={"RS"} />
                  :
                  <ProdutoSelect
                    estado={"RS"}
                    entrada_saida={this.obs.calc.entrada ? "entrada" : "saida"}
                    value={this.obs.calc.produtos}
                    onChange={vals => this.obs.calc.produtos = vals} />
                }
              </FormGroup>

              <Button
                icon="import"
                className="btnRoxo btnExportExcel"
                onClick={() => this.openImportProdutos()}
              >
                Importar Produtos
              </Button>

              &nbsp;

              <Button
                icon="export"
                className="btnRoxo btnExportExcel"
                onClick={() => this.handleExport()}
                disabled={this.obs.calc.confaz == 0}
              >
                Exportar Produtos
              </Button>
            </>
          }
        </div>

        <div className="nz-horizontal-form">
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar ao Simples"
              checked={this.obs.calc.simples_nacional}
              onChange={(e: any) => this.obs.calc.simples_nacional = e.target.checked}
            />
          </div>
          {this.obs.calc.simples_nacional &&
            <div className="horizontal">
              <Switch
                className="select-regras"
                label="Simples Nacional Excesso"
                checked={this.obs.calc.simples_nacional_excesso}
                onChange={(e: any) => this.obs.calc.simples_nacional_excesso = e.target.checked}
              />
            </div>
          }
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Regime Especial"
              checked={this.obs.calc.regime_especial}
              onChange={(e: any) => {
                this.obs.calc.regime_especial = e.target.checked
                this.obs.calc.regime_e_sem_regime = false
              }}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Regime Normal"
              checked={this.obs.calc.regime_e_sem_regime}
              onChange={(e: any) => {
                this.obs.calc.regime_e_sem_regime = e.target.checked
                this.obs.calc.regime_especial = false
              }}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Porta a porta"
              checked={this.obs.calc.porta_a_porta}
              onChange={(e: any) => this.obs.calc.porta_a_porta = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Devolução"
              checked={this.obs.calc.devolucao}
              onChange={(e: any) => this.obs.calc.devolucao = e.target.checked}
            />
          </div>
        </div>
        <div className="nz-horizontal-form">
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar à saída"
              checked={this.obs.calc.saida}
              onChange={(e: any) => this.obs.calc.saida = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar à entrada"
              checked={this.obs.calc.entrada}
              onChange={(e: any) => this.obs.calc.entrada = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar à NF-e"
              checked={this.obs.calc.nfe}
              onChange={(e: any) => this.obs.calc.nfe = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar à CT-e"
              checked={this.obs.calc.cte}
              onChange={(e: any) => this.obs.calc.cte = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar à NFC-e"
              checked={this.obs.calc.nfce}
              onChange={(e: any) => this.obs.calc.nfce = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar à NFS-e"
              checked={this.obs.calc.nfse}
              disabled={this.obs.calc.nfe || this.obs.calc.cte || this.obs.calc.nfce}
              onChange={(e: any) => this.handleChangeNfse(e.target.checked)}
            />
          </div>
        </div>

        <div className="nz-horizontal-form">
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar 12%"
              checked={this.obs.calc.aplica_12}
              onChange={(e: any) => this.obs.calc.aplica_12 = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar Importados"
              checked={this.obs.calc.aplica_importados}
              onChange={(e: any) => this.obs.calc.aplica_importados = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar Interno (Estado)"
              checked={this.obs.calc.aplica_interno}
              onChange={(e: any) => this.obs.calc.aplica_interno = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Medicamento Veterinário PET"
              checked={this.obs.calc.medicamento_uso_veterinario}
              onChange={(e: any) => this.obs.calc.medicamento_uso_veterinario = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Auto peças"
              checked={this.obs.calc.auto_pecas}
              onChange={(e: any) => this.obs.calc.auto_pecas = e.target.checked}
            />
          </div>
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Varejista"
              checked={this.obs.calc.varejista}
              onChange={(e: any) => this.obs.calc.varejista = e.target.checked}
            />
          </div>
        </div>

        <div className="nz-horizontal-form">
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Forçar Cest"
              checked={this.obs.calc.force_cest}
              onChange={(e: any) => this.obs.calc.force_cest = e.target.checked}
            />
          </div>
          {this.obs.calc.simples_nacional &&
            <>
              <div className="horizontal">
                <Switch
                  className="select-regras"
                  label="Forçar CSON"
                  checked={this.obs.calc.force_cson}
                  onChange={(e: any) => this.obs.calc.force_cson = e.target.checked}
                />
              </div>
              <div className="horizontal">
                <Switch
                  className="select-regras"
                  labelElement={<>
                    Forçar CFOP&nbsp;
                    <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.obs.open_forcar_cfop = true;
                    }} />
                  </>}
                  checked={this.obs.calc.force_cfop}
                  onChange={(e: any) => this.obs.calc.force_cfop = e.target.checked}
                />
              </div>
            </>
          }
          <div className="horizontal">
            <Switch
              className="select-regras"
              label="Aplicar ao convênio 100/97 Art. 64 RICMS"
              checked={this.obs.calc.convenio_icms_100_97}
              onChange={(e: any) => this.obs.calc.convenio_icms_100_97 = e.target.checked}
            />
          </div>
        </div>

        {this.obs.calc.simples_nacional && this.obs.calc.saida &&
          (
            <FormGroup label="Simples Nacional">
              <FormGroup className="empresaSelect selectValues" label="Anexo">
                <DefaultSelect
                  items={anexos}
                  itemRenderer={renderItens}
                  itemPredicate={filterItens}
                  onItemSelect={(e: any) => this.handleChangeAnexo(e)}
                  matchTargetWidth={true}
                  inputProps={{ placeholder: "Filtrar um anexo" }}
                >
                  <Button
                    text={anexoText}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </DefaultSelect>
              </FormGroup>

              <FormGroup className="empresaSelect selectValues" label="Seção">
                <DefaultSelect
                  items={secao}
                  itemRenderer={renderItens}
                  itemPredicate={filterItens}
                  onItemSelect={(e: any) => this.handleChangeSecao(e)}
                  matchTargetWidth={true}
                  inputProps={{ placeholder: "Filtrar uma seção" }}
                >
                  <Button
                    text={secaoText}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                    disabled={this.obs.anexo.cod == "" ? true : false}
                  />
                </DefaultSelect>
              </FormGroup>

              <FormGroup className="empresaSelect selectValues" label="Tabela">
                <DefaultSelect
                  items={tabela}
                  itemRenderer={renderItens}
                  itemPredicate={filterItens}
                  onItemSelect={(e: any) => { this.obs.calc.tabela = e; this.obs.tabela = e }}
                  matchTargetWidth={true}
                  inputProps={{ placeholder: "Filtrar uma tabela" }}
                >
                  <Button
                    text={tabelaText}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                    disabled={this.obs.anexo.cod != "" && this.obs.secao.cod != "" ? false : true}
                  />
                </DefaultSelect>
              </FormGroup>

              <Switch
                className="select-regras"
                label="Serviços não aplicados"
                checked={this.obs.calc.sem_servicos}
                onChange={(e: any) => this.handleChangeSemServicos(e)}
              />
              {!this.obs.calc.sem_servicos &&
                <>
                  <b>Revenda de mercadorias, exceto para o exterior</b>
                  <Switch
                    className="select-regras"
                    label="Sem substituição tributária/tributação monofásica/antecipação com encerramento de tributação (o substituto tributário do ICMS deve utilizar essa opção)"
                    checked={this.obs.calc.revenda_sem_st}
                    onChange={(e: any) => this.obs.calc.revenda_sem_st = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Com substituição tributária/tributação monofásica/antecipação com encerramento de tributação (o substituído tributário do ICMS deve utilizar essa opção)"
                    checked={this.obs.calc.revenda_com_st}
                    onChange={(e: any) => this.obs.calc.revenda_com_st = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Revenda de mercadorias para o exterior"
                    checked={this.obs.calc.revenda_exterior}
                    onChange={(e: any) => this.obs.calc.revenda_exterior = e.target.checked}
                  />

                  <b>
                    Venda de mercadorias industrializadas pelo contribuinte, exceto
                    para o exterior
                  </b>
                  <Switch
                    className="select-regras"
                    label="Sem substituição tributária/tributação monofásica/antecipação com encerramento de tributação (o substituto tributário do ICMS deve utilizar essa opção)"
                    checked={this.obs.calc.venda_sem_st}
                    onChange={(e: any) => this.obs.calc.venda_sem_st = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Com substituição tributária/tributação monofásica/antecipação com encerramento de tributação (o substituído tributário do ICMS deve utilizar essa opção)"
                    checked={this.obs.calc.venda_com_st}
                    onChange={(e: any) => this.obs.calc.venda_com_st = e.target.checked}
                  />

                  <Switch
                    className="select-regras"
                    label="Venda de mercadorias industrializadas pelo contribuinte para o exterior"
                    checked={this.obs.calc.venda_exterior}
                    onChange={(e: any) => this.obs.calc.venda_exterior = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Locação de bens móveis, exceto para o exterior"
                    checked={this.obs.calc.venda_locacao_nao_exterior}
                    onChange={(e: any) => this.obs.calc.venda_locacao_nao_exterior = e.target.checked}
                  />

                  <Switch
                    className="select-regras"
                    label="Locação de bens móveis para o exterior"
                    checked={this.obs.calc.venda_locacao_exterior}
                    onChange={(e: any) => this.obs.calc.venda_locacao_exterior = e.target.checked}
                  />

                  <b>
                    Prestação de Serviços, exceto para o exterior
                  </b>
                  <Switch
                    className="select-regras"
                    label="Escritórios de serviços contábeis autorizados pela legislação municipal a pagar o ISS em valor fixo em guia do Município"
                    checked={this.obs.calc.servicos_contabeis}
                    onChange={(e: any) => this.obs.calc.servicos_contabeis = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao fator “r”, sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)"
                    checked={this.obs.calc.servicos_fator_outro_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_fator_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao fator “r”, sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.servicos_fator_proprio_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_fator_proprio_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao fator “r”, com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.servicos_fator_com_retencao}
                    onChange={(e: any) => this.obs.calc.servicos_fator_com_retencao = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Não sujeitos ao fator “r” e tributados pelo Anexo III, sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)"
                    checked={this.obs.calc.servicos_nao_fator_outro_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_nao_fator_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Não sujeitos ao fator “r” e tributados pelo Anexo III, sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.servicos_nao_fator_proprio_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_nao_fator_proprio_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Não sujeitos ao fator “r” e tributados pelo Anexo III, com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.servicos_nao_fator_com_retencao}
                    onChange={(e: any) => this.obs.calc.servicos_nao_fator_com_retencao = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao Anexo IV, sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)"
                    checked={this.obs.calc.servicos_anexo_IV_outro_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_anexo_IV_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao Anexo IV, sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.servicos_anexo_IV_proprio_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_anexo_IV_proprio_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao Anexo IV, com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.servicos_anexo_IV_com_retencao}
                    onChange={(e: any) => this.obs.calc.servicos_anexo_IV_com_retencao = e.target.checked}
                  />

                  <b>
                    Prestação de Serviços relacionados nos subitens 7.02, 7.05 e 16.1 da lista anexa à LC 116/2003, exceto para o exterior
                  </b>
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo III, sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)"
                    checked={this.obs.calc.servicos_construcao_III_outro_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_construcao_III_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo III, sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.servicos_construcao_III_mesmo_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_construcao_III_mesmo_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo III, com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.servicos_construcao_III_com_retencao_substituicao}
                    onChange={(e: any) => this.obs.calc.servicos_construcao_III_com_retencao_substituicao = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo IV, sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)"
                    checked={this.obs.calc.servicos_construcao_IV_outro_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_construcao_IV_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo IV, sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.servicos_construcao_IV_mesmo_municipio}
                    onChange={(e: any) => this.obs.calc.servicos_construcao_IV_mesmo_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo IV, com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.servicos_construcao_IV_com_retencao_substituicao}
                    onChange={(e: any) => this.obs.calc.servicos_construcao_IV_com_retencao_substituicao = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros, sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s) "
                    checked={this.obs.calc.transporte_coletivo_outro_municipio}
                    onChange={(e: any) => this.obs.calc.transporte_coletivo_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros, sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.transporte_coletivo_mesmo_municipio}
                    onChange={(e: any) => this.obs.calc.transporte_coletivo_mesmo_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços de transporte coletivo municipal rodoviário, metroviário, ferroviário e aquaviário de passageiros, com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.transporte_coletivo_com_retencao_substituicao}
                    onChange={(e: any) => this.obs.calc.transporte_coletivo_com_retencao_substituicao = e.target.checked}
                  />

                  <b>
                    Prestação de Serviços para o exterior
                  </b>
                  <Switch
                    className="select-regras"
                    label="Escritórios de serviços contábeis autorizados pela legislação municipal a pagar o ISS em valor fixo em guia do Município"
                    checked={this.obs.calc.servicos_exterior_escritorios}
                    onChange={(e: any) => this.obs.calc.servicos_exterior_escritorios = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao fator “r”"
                    checked={this.obs.calc.servicos_exterior_fator}
                    onChange={(e: any) => this.obs.calc.servicos_exterior_fator = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Não sujeitos ao fator “r” e tributados pelo Anexo III"
                    checked={this.obs.calc.servicos_exterior_nao_fator}
                    onChange={(e: any) => this.obs.calc.servicos_exterior_nao_fator = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sujeitos ao Anexo IV"
                    checked={this.obs.calc.servicos_exterior_anexo}
                    onChange={(e: any) => this.obs.calc.servicos_exterior_anexo = e.target.checked}
                  />

                  <b>
                    Prestação de Serviços relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003, para o exterior
                  </b>
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo III"
                    checked={this.obs.calc.servicos_exterior_construcao_anexo_III}
                    onChange={(e: any) => this.obs.calc.servicos_exterior_construcao_anexo_III = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Serviços da área da construção civil relacionados nos subitens 7.02 e 7.05 da lista anexa à LC 116/2003 e tributados pelo Anexo IV"
                    checked={this.obs.calc.servicos_exterior_construcao_anexo_IV}
                    onChange={(e: any) => this.obs.calc.servicos_exterior_construcao_anexo_IV = e.target.checked}
                  />
                  <b>
                    Serviços de comunicação; de transporte intermunicipal e
                    interestadual de carga; e de transporte intermunicipal e
                    interestadual de passageiros autorizados no inciso VI do art. 17
                    da LC 123, exceto para o exterior
                  </b>

                  <Switch
                    className="select-regras"
                    label="Transporte sem substituição tributária de ICMS (o substituto tributário deve utilizar essa opção)"
                    checked={this.obs.calc.transporte_sem_st}
                    onChange={(e: any) => this.obs.calc.transporte_sem_st = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Transporte com substituição tributária de ICMS (o substituído tributário deve utilizar essa opção)"
                    checked={this.obs.calc.transporte_com_st}
                    onChange={(e: any) => this.obs.calc.transporte_com_st = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Comunicação sem substituição tributária de ICMS (o substituto tributário deve utilizar essa opção)"
                    checked={this.obs.calc.comunicacao_sem_st}
                    onChange={(e: any) => this.obs.calc.comunicacao_sem_st = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Comunicação com substituição tributária de ICMS (o substituído tributário deve utilizar essa opção)"
                    checked={this.obs.calc.comunicacao_com_st}
                    onChange={(e: any) => this.obs.calc.comunicacao_com_st = e.target.checked}
                  />

                  <b>
                    Serviços de comunicação; de transporte intermunicipal e
                    interestadual de carga; e de transporte intermunicipal e
                    interestadual de passageiros autorizados no inciso VI do art. 17
                    da LC 123, para o exterior
                  </b>
                  <div className="nz-horizontal-form">
                    <div className="horizontal">
                      <Switch
                        className="select-regras"
                        label="Transporte"
                        checked={this.obs.calc.transporte}
                        onChange={(e: any) => this.obs.calc.transporte = e.target.checked}
                      />
                    </div>
                    <div className="horizontal">
                      <Switch
                        className="select-regras"
                        label="Comunicação"
                        checked={this.obs.calc.comunicacao}
                        onChange={(e: any) => this.obs.calc.comunicacao = e.target.checked}
                      />
                    </div>
                  </div>

                  <b>
                    Atividades com incidência simultânea de IPI e de ISS, exceto para o exterior
                  </b>
                  <Switch
                    className="select-regras"
                    label="Sem retenção/substituição tributária de ISS, com ISS devido a outro(s) Município(s)"
                    checked={this.obs.calc.atividades_ipi_iss_outro_municipio}
                    onChange={(e: any) => this.obs.calc.atividades_ipi_iss_outro_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Sem retenção/substituição tributária de ISS, com ISS devido ao próprio Município do estabelecimento"
                    checked={this.obs.calc.atividades_ipi_iss_mesmo_municipio}
                    onChange={(e: any) => this.obs.calc.atividades_ipi_iss_mesmo_municipio = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Com retenção/substituição tributária de ISS"
                    checked={this.obs.calc.atividades_ipi_iss_com_retencao_substituicao}
                    onChange={(e: any) => this.obs.calc.atividades_ipi_iss_com_retencao_substituicao = e.target.checked}
                  />
                  <Switch
                    className="select-regras"
                    label="Atividades com incidência simultânea de IPI e de ISS para o exterior"
                    checked={this.obs.calc.atividades_ipi_iss_exterior}
                    onChange={(e: any) => this.obs.calc.atividades_ipi_iss_exterior = e.target.checked}
                  />
                </>
              }

              {this.obs.calc.nfse ? <b>PIS/COFINS/ISS/IRPJ/CSLL/CPP</b> : <b>PIS/COFINS/ICMS/IRPJ/CSLL/CPP</b>}

              <Switch
                className="select-regras"
                label="COFINS"
                checked={this.obs.calc.cofins}
                onChange={(e: any) => this.obs.calc.cofins = e.target.checked}
              />
              {this.obs.calc.simples_nacional && !this.obs.calc.cofins &&
                (
                  <FormGroup label="COFINS Tributações">
                    <div className="nz-horizontal-form">
                      <div className="horizontal">
                        <Switch
                          className="select-regras"
                          label="Lançamento de ofício"
                          checked={this.obs.calc.cofins_lancamento_oficio}
                          onChange={(e: any) => this.obs.calc.cofins_lancamento_oficio = e.target.checked}
                        />
                      </div>
                      <div className="horizontal"><Switch
                        className="select-regras"
                        label="Substituição Tributária"
                        checked={this.obs.calc.cofins_st}
                        onChange={(e: any) => this.obs.calc.cofins_st = e.target.checked}
                      />
                      </div>
                      <div className="horizontal"><Switch
                        className="select-regras"
                        label="Tributação Monofásica"
                        checked={this.obs.calc.cofins_tributacao_monofasica}
                        onChange={(e: any) => this.obs.calc.cofins_tributacao_monofasica = e.target.checked}
                      />
                      </div>
                    </div>
                  </FormGroup>

                )}
              <Switch
                className="select-regras"
                label="PIS/PASED"
                checked={this.obs.calc.pis_pased}
                onChange={(e: any) => this.obs.calc.pis_pased = e.target.checked}
              />
              {this.obs.calc.simples_nacional && !this.obs.calc.pis_pased &&
                (
                  <FormGroup label="PIS/PASED Tributações">
                    <div className="nz-horizontal-form">
                      <div className="horizontal">
                        <Switch
                          className="select-regras"
                          label="Lançamento de ofício"
                          checked={this.obs.calc.pis_pased_lancamento_oficio}
                          onChange={(e: any) => this.obs.calc.pis_pased_lancamento_oficio = e.target.checked}
                        />
                      </div>
                      <div className="horizontal">
                        <Switch
                          className="select-regras"
                          label="Substituição Tributária"
                          checked={this.obs.calc.pis_pased_st}
                          onChange={(e: any) => this.obs.calc.pis_pased_st = e.target.checked}
                        />
                      </div>
                      <div className="horizontal">
                        <Switch
                          className="select-regras"
                          label="Tributação Monofásica"
                          checked={this.obs.calc.pis_pased_tributacao_monofasica}
                          onChange={(e: any) => this.obs.calc.pis_pased_tributacao_monofasica = e.target.checked}
                        />
                      </div>
                    </div>
                  </FormGroup>

                )}
              {this.obs.calc.nfse ?
                <>
                  <Switch
                    className="select-regras"
                    label="ISS"
                    checked={this.obs.calc.iss}
                    onChange={(e: any) => this.obs.calc.iss = e.target.checked}
                  />
                  {!this.obs.calc.iss &&
                    (
                      <FormGroup label="ISS Tributações">
                        <div className="nz-horizontal-form">
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Imunidade"
                              checked={this.obs.calc.iss_imunidade}
                              onChange={(e: any) => this.obs.calc.iss_imunidade = e.target.checked}
                            />
                          </div>
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Exigibilidade Suspensa"
                              checked={this.obs.calc.iss_imunidade}
                              onChange={(e: any) => this.obs.calc.iss_imunidade = e.target.checked}
                            />
                          </div>
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Lançamento de Ofício"
                              checked={this.obs.calc.iss_lancamento_oficio}
                              onChange={(e: any) => this.obs.calc.iss_lancamento_oficio = e.target.checked}
                            />
                          </div>
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Redução"
                              checked={this.obs.calc.iss_reducao}
                              onChange={(e: any) => this.obs.calc.iss_reducao = e.target.checked}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    )}
                </>

                :
                <>

                  <Switch
                    className="select-regras"
                    label="ICMS"
                    checked={this.obs.calc.icms}
                    onChange={(e: any) => this.obs.calc.icms = e.target.checked}
                  />
                  {this.obs.calc.simples_nacional && !this.obs.calc.icms &&
                    (
                      <FormGroup label="ICMS Tributações">
                        <div className="nz-horizontal-form">
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Imunidade"
                              checked={this.obs.calc.icms_imunidade}
                              onChange={(e: any) => this.obs.calc.icms_imunidade = e.target.checked}
                            />
                          </div>
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Lançamento de Ofício"
                              checked={this.obs.calc.icms_lancamento_oficio}
                              onChange={(e: any) => this.obs.calc.icms_lancamento_oficio = e.target.checked}
                            />
                          </div>
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Substituição Tributária"
                              checked={this.obs.calc.icms_st}
                              onChange={(e: any) => this.obs.calc.icms_st = e.target.checked}
                            />
                          </div>
                          <div className="horizontal">
                            <Switch
                              className="select-regras"
                              label="Antecipação Encerramento Tributação"
                              checked={this.obs.calc.icms_antecipacao_encerramento_tributacao}
                              onChange={(e: any) => this.obs.calc.icms_antecipacao_encerramento_tributacao = e.target.checked}
                            />
                          </div>
                        </div>
                      </FormGroup>

                    )}
                </>

              }
              <Switch
                className="select-regras"
                label="IRPJ"
                checked={this.obs.calc.irpj}
                onChange={(e: any) => this.obs.calc.irpj = e.target.checked}
              />
              {this.obs.calc.simples_nacional && !this.obs.calc.irpj &&
                (
                  <FormGroup label="IRPJ Tributações">
                    <div className="horizontal">
                      <Switch
                        className="select-regras"
                        label="Lançamento de Ofício"
                        checked={this.obs.calc.irpj_lancamento_oficio}
                        onChange={(e: any) => this.obs.calc.irpj_lancamento_oficio = e.target.checked}
                      />
                    </div>
                  </FormGroup>

                )}
              <Switch
                className="select-regras"
                label="CSLL"
                checked={this.obs.calc.csll}
                onChange={(e: any) => this.obs.calc.csll = e.target.checked}
              />
              {this.obs.calc.simples_nacional && !this.obs.calc.csll &&
                (
                  <FormGroup label="CSLL Tributações">
                    <div className="horizontal">
                      <Switch
                        className="select-regras"
                        label="Lançamento de Ofício"
                        checked={this.obs.calc.csll_lancamento_oficio}
                        onChange={(e: any) => this.obs.calc.csll_lancamento_oficio = e.target.checked}
                      />
                    </div>
                  </FormGroup>

                )}
              <Switch
                className="select-regras"
                label="CPP"
                checked={this.obs.calc.cpp}
                onChange={(e: any) => this.obs.calc.cpp = e.target.checked}
              />
              {this.obs.calc.simples_nacional && !this.obs.calc.cpp &&
                (
                  <FormGroup label="CPP Tributações">
                    <div className="horizontal">
                      <Switch
                        className="select-regras"
                        label="Lançamento de Ofício"
                        checked={this.obs.calc.cpp_lancamento_oficio}
                        onChange={(e: any) => this.obs.calc.cpp_lancamento_oficio = e.target.checked}
                      />
                    </div>
                  </FormGroup>

                )}
            </FormGroup>

          )}


        <Tabs
          id="tabs"
          className={"tabsCalculos calcs"}
          onChange={(tableId) => this.handleChangeTab(tableId)}
          selectedTabId={CalcRSStore.obs.tab_codigos}
        >
          <Tab id="origem" title="CSTs Origem" panel={<>

            <FormGroup label="Aplicar aos códigos CSTs Origem" style={{ marginRight: 15 }}>
              <CstOrigemMultiSelect
                value={this.obs.calc.list_csts_origem}
                onChange={vals => this.obs.calc.list_csts_origem = vals} />
            </FormGroup>

          </>} />

          <Tab id="cfops" title="CFOPs" panel={<>

            <FormGroup label="Aplicar aos códigos CFOPs" style={{ marginRight: 15 }}>
              <CfopMultiSelect
                value={this.obs.calc.list_cfops}
                onChange={vals => this.obs.calc.list_cfops = vals} />
            </FormGroup>

          </>} />

          <Tab id="csts" title="CSTs" panel={<>

            <FormGroup label="Aplicar aos códigos CSTs" style={{ marginRight: 15 }}>
              <CstMultiSelect
                value={this.obs.calc.list_csts}
                onChange={vals => this.obs.calc.list_csts = vals} />
            </FormGroup>

          </>} />

          {this.obs.calc.simples_nacional && this.obs.calc.saida &&
            <Tab id="pis_cofins" title="PIS-COFINS" panel={<>

              <FormGroup label="Aplicar aos códigos PIS-COFINS" style={{ marginRight: 15 }}>
                <PisCofinsMultiSelect
                  value={this.obs.calc.list_pis_cofins}
                  onChange={vals => this.obs.calc.list_pis_cofins = vals} />
              </FormGroup>

            </>} />
          }

          {this.obs.calc.nfse &&
            <Tab id="tribu_nacional" title="Tributação Nacional" panel={<>

              <FormGroup label="Aplicar aos códigos Tributação Nacional" style={{ marginRight: 15 }}>
                <TribuNacionalMultiSelect
                  value={this.obs.calc.list_tribu_nacional}
                  onChange={vals => this.obs.calc.list_tribu_nacional = vals} />
              </FormGroup>

            </>} />
          }
        </Tabs>

        <InfoModal open={this.obs.open_forcar_cfop} onClose={() => this.obs.open_forcar_cfop = false} texto_info={`
          Ao habilitar essa flag para os cálculos sugeridos do Simples Nacional, os campos CST e CFOP passam a ser validados. Caso permaneça desabilitada, os campos CST e CFOP não serão validados!
        `} />
      </>
    );
  }

  handleCreateBCVar = () => {
    this.obs.creatingVar = true;
    this.obs.editingVar = {
      id: null,
      order: this.obs.calc.vars.length + 1,
      nome: "BC",
      expr: "",
      descricao: "",
      saida: false,
      entrada: false,
    };
  };

  handleCreateBCVarFcp = () => {
    this.obs.creatingVarFcp = true;
    this.obs.editingVarFcp = {
      id: null,
      order: this.obs.calc.vars_fcp.length + 1,
      nome: "BC",
      expr: "",
      descricao: "",
      saida: false,
      entrada: false,
    };
  };

  renderVariables() {
    let createBcButton = (
      <Tooltip content="Uma variável com este nome não existe. Clique para criar.">
        <Button
          icon="warning-sign"
          minimal
          intent="warning"
          onClick={this.handleCreateBCVar}
        />
      </Tooltip>
    );

    let hasBcVar = false;
    this.obs.calc.vars?.forEach(v => {
      if (v.nome.toUpperCase() == "BC") hasBcVar = true;
    });

    let nonIdeal = <NonIdealState icon="box" title="Não há variáveis" />;

    return (
      <>
        <div className="nz-horizontal-form" style={{ marginBottom: 10 }}>
          <FormGroup
            label="&nbsp;"
            helperText="A última variável será o resultado do cálculo."
            style={{ marginRight: 15 }}
          >
            <Button
              icon="add"
              text="Criar nova variável"
              onClick={this.handleCreateVar}
            />
          </FormGroup>

          <FormGroup
            label="Variável da Base do Cálculo"
            labelFor="bc_var"
            labelInfo="(obrigatório)"
            helperText="O nome da variável na lista abaixo que será utilizada para o campo, 'Base do Cálculo'."
          >
            <div style={{ width: 130 }}>
              <InputGroup
                id="bc_var"
                value={this.obs.calc.bc_var}
                onChange={(e: any) => this.obs.calc.bc_var = e.target.value}
                rightElement={!hasBcVar && createBcButton}
              />
            </div>
          </FormGroup>

        </div>

        {this.obs.calc.vars.length == 0 && nonIdeal}

        <CalcVarGrid
          vars={this.obs.calc.vars}
          onMoveUp={this.handleMoveVarUp}
          onMoveDown={this.handleMoveVarDown}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
        />

        {this.obs.editingVar && (
          <CalcVarDialog
            calcVar={this.obs.editingVar}
            onClose={this.handleCalcVarDialogClose}
            allVars={this.obs.calc.vars}
            onConfirm={this.handleCalcVarDialogConfirm}
          />
        )}
      </>
    );
  }

  renderVariablesFCP() {
    let createBcButton = (
      <Tooltip content="Uma variável com este nome não existe. Clique para criar.">
        <Button
          icon="warning-sign"
          minimal
          intent="warning"
          onClick={this.handleCreateBCVarFcp}
        />
      </Tooltip>
    );

    let hasBcVar = false;
    this.obs.calc.vars_fcp?.forEach(v => {
      if (v.nome.toUpperCase() == "BC") hasBcVar = true;
    });

    let nonIdeal = <NonIdealState icon="box" title="Não há variáveis" />;

    return (
      <>
        <div className="nz-horizontal-form" style={{ marginBottom: 10 }}>
          <FormGroup
            label="&nbsp;"
            helperText="A última variável será o resultado do cálculo."
            style={{ marginRight: 15 }}
          >
            <Button
              icon="add"
              text="Criar nova variável"
              onClick={this.handleCreateVarFcp}
            />
          </FormGroup>

          <FormGroup
            label="Variável da Base do Cálculo"
            labelFor="bc_var_fcp"
            labelInfo="(obrigatório)"
            helperText="O nome da variável na lista abaixo que será utilizada para o campo, 'Base do Cálculo'."
          >
            <div style={{ width: 130 }}>
              <InputGroup
                id="bc_var_fcp"
                value={this.obs.calc.bc_var_fcp}
                onChange={(e: any) => this.obs.calc.bc_var_fcp = e.target.value}
                rightElement={!hasBcVar && createBcButton}
              />
            </div>
          </FormGroup>

        </div>

        {this.obs.calc.vars_fcp?.length == 0 && nonIdeal}

        <CalcVarFcpGrid
          varsFcp={this.obs.calc.vars_fcp}
          onMoveUp={this.handleMoveVarFcpUp}
          onMoveDown={this.handleMoveVarFcpDown}
          onEdit={this.handleEditFcp}
          onDelete={this.handleDeleteFcp}
        />

        {this.obs.editingVarFcp && (
          <CalcVarFcpDialog
            calcVar={this.obs.editingVarFcp}
            onClose={this.handleCalcVarFcpDialogClose}
            allVarsFcp={this.obs.calc.vars_fcp}
            onConfirm={this.handleCalcVarFcpDialogConfirm}
          />
        )}
      </>
    );
  }

  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.listContas.push(row.id);

    } else {

      let index = this.obs.listContas.indexOf(row.id);

      this.obs.listContas.splice(index, 1);

    }

  };

  handleRowSelectAll = async (check, row) => {

    if (check) {

      toast.warning('Para realizar o Cálculo em todas as Contas, simplesmente deixe a seleção de conta em branco!', {});

      this.obs.listContas = [];

    } else {

      this.obs.listContas = [];

    }

  };

  handleRowSelectEmp = async (row, checked) => {

    if (checked) {

      this.obs.listempresas.push(row.cnpj);

    } else {

      let index = this.obs.listempresas.indexOf(row.cnpj);

      this.obs.listempresas.splice(index, 1);

    }

  };

  handleRowSelectEmpAll = async (check, row) => {

    if (check) {

      toast.warning('Para realizar o Cálculo em todas as Empresas, simplesmente deixe a seleção de empresas em branco e marque a conta desejada!', {});

      this.obs.listempresas = [];

    } else {

      this.obs.listempresas = [];

    }
  };

  renderSelectContas() {

    const selectRowProp = {
      mode: "checkbox",
      columnWidth: "40px",
      clickToSelect: false,
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      isSelected: true,
      selected: this.obs.listContas,
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    const selectRowPropEmp = {
      mode: "checkbox",
      columnWidth: "40px",
      clickToSelect: true,
      onSelect: this.handleRowSelectEmp,
      onSelectAll: this.handleRowSelectEmpAll,
      isSelected: true,
      selected: this.obs.listempresas,
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    let select_contas = CalcRSStore.filtered?.map(value => {
      return ({
        id: value.id,
        razao_social: value.razao_social,
        nome: value.nome,
        empresas: value.empresas
      })
    });


    const formatEmpresas = (cell, row) => {
      return (<>
        <img src="/images/business.png" width="20px" onClick={() => this.openSelectEmpresas(row)} style={{ cursor: "pointer" }} />
      </>)
    }

    let empresas = sortBy((this.obs.empresas.empresas || []), "razao_social")?.map(value => {
      return ({
        razao_social: value.razao_social,
        cnpj: value.cnpj,
      })
    });

    const options = {
      searchField: this.createCustomSearchField,
    };

    return (

      <>

        <p style={{ color: "red", fontSize: 12 }}>Atenção: Se este for um cálculo exclusivo, marque a opção <b>Cálculo Exclusivo</b> na aba <b>Detalhes</b>.</p>

        <InputGroup
          style={{ width: 400 }}
          placeholder="Filtrar"
          value={CalcRSStore.obs.filter}
          onChange={(e) => CalcRSStore.obs.filter = e.target.value}
        />

        <br />

        <FormGroup label="Selecione as Contas:">
          <div className="select-contas-calcs" style={{ width: "50%" }}>
            <BootstrapTable data={select_contas} selectRow={selectRowProp}>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="5%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="nome" width="75%">Nome</TableHeaderColumn>
              <TableHeaderColumn dataFormat={formatEmpresas} width="20%">Empresas</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </FormGroup>

        <Dialog
          isOpen={this.obs.open_empresas}
          onClose={() => this.handleCloseEmpresas()}
          title={this.obs.empresas.nome}
          className="modal-empresas"
        >
          <div className={Classes.DIALOG_BODY}>

            <div style={{ overflow: "auto", height: 550, paddingRight: 20 }}>
              <BootstrapTable data={empresas} selectRow={selectRowPropEmp} options={options} search>
                <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="80%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>

          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="none" onClick={() => this.handleCloseEmpresas()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleCloseEmpresas()} />
            </div>
          </div>
        </Dialog>

      </>
    )
  }

  renderDescritivoCalculo() {

    const setText = (value: string) => {

      const html = value || "";

      const text = html.replace(/<[^>]+>/g, "");

      this.obs.calc.descritivo_calculo = value

    }

    const header = (
      <div id="toolbar-container">
        <span className="ql-formats">
          <select className="ql-font"></select>
          <select className="ql-size"></select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold"></button>
          <button className="ql-italic"></button>
          <button className="ql-underline"></button>
          <button className="ql-strike"></button>
        </span>
        <span className="ql-formats">
          <select className="ql-color"></select>
          <select className="ql-background"></select>
        </span>
        <span className="ql-formats">
          <button className="ql-list" value="ordered"></button>
          <button className="ql-list" value="bullet"></button>
          <button className="ql-indent" value="-1"></button>
          <button className="ql-indent" value="+1"></button>
        </span>
        <span className="ql-formats">
          <select className="ql-align"></select>
        </span>
        <span className="ql-formats">
          <button className="ql-link"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-clean"></button>
        </span>
      </div>
    );

    return (

      <>

        <Editor value={this.obs.calc.descritivo_calculo} onTextChange={(e) => setText(e.htmlValue)} style={{ height: '600px' }} headerTemplate={header} />

        <br/>

      </>

    )

  }

}

export default CalcRsForm;
